/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const PaperAirplane16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M8.325 16c.557 0 .94-.415 1.179-1.037L13.844 3.6A2 2 0 0014 2.888c0-.545-.343-.888-.881-.888-.214 0-.46.052-.72.155L1.012 6.51C.42 6.729 0 7.112 0 7.682c0 .654.473.945 1.14 1.146l3.084.953c.525.162.849.162 1.244-.195l7.418-6.77c.103-.097.233-.084.31-.013.072.078.085.208-.006.311l-6.77 7.412c-.324.356-.356.751-.2 1.25l.939 3.051c.207.68.499 1.173 1.166 1.173z"
        />
    </AccessibleSVG>
);

export default PaperAirplane16;
